<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#info" role="tab"
                           aria-selected="false">
                            {{ $t('application.app_info') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#service_wages" role="tab"
                           aria-selected="false">
                            {{ $t('application.service_wages') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#credit_verification" role="tab"
                           aria-selected="false">
                            {{ $t('application.credit_verification') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#gateway_refund_setting" role="tab"
                           aria-selected="false">
                            {{ $t('application.ipg_gateway_transaction_refund') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div class="tab-pane active" id="info">
                    <application-info :application="application"></application-info>
                </div>
                <div class="tab-pane" id="service_wages">
                    <service-wages></service-wages>
                </div>
                <div v-if="application" class="tab-pane" id="credit_verification">
                    <application-statement :bank_accounts="application.bank_accounts"></application-statement>
                </div>
                <div v-if="application" class="tab-pane" id="gateway_refund_setting">
                    <gateway-refund-setting :bank_accounts="application.bank_accounts"></gateway-refund-setting>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</template>

<script>


import ApplicationInfo from './application-info.vue'
import ServiceWages from './service-wages.vue'
import ApplicationStatement from './application-statement.vue'
import GatewayRefundSetting from './gateway-refund-setting.vue'
import {openBankingService} from "@/common/api.service";

export default {
    components: {
        'application-info': ApplicationInfo,
        'service-wages': ServiceWages,
        'application-statement': ApplicationStatement,
        'gateway-refund-setting': GatewayRefundSetting,
    },
    data() {
        return {
            application : null,
            'hashid': this.$route.params.hashid,
        }
    },
    mounted() {
        openBankingService.adminFindApplication(this.hashid).then(response => {
            this.application = response.data.data.application;
        });
    }
}
</script>